var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"calc(100vh - 48px)","position":"relative"}},[_c('Report')],1)}
var staticRenderFns = []

export { render, staticRenderFns }